import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { JobDetailComponent } from '../components/career/job-detail.component';
import { CareerComponent } from '../components/career/career.component';

export const careerRoutes = {
    path: 'career',
    data: {
        breadcrumbs: {
            label: 'Kariéra',
            icon: 'users'
        },
        state: 'career'
    },
    children: [
        {
            path: '',
            component: CareerComponent
        },
        {
            path: 'jobs/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat nabídku'
                },
                state: 'career-add'
            },
            children: [
                {
                    path: '',
                    component: JobDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'career-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'career-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'career-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'career/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit produkt'
                },
                state: 'product-edit'
            },
            children: [
                {
                    path: '',
                    component: JobDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'career-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'career-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'career-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'career-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat článek'
                },
                state: 'jobs-delete',
                apiUri: 'jobs'
            },
            outlet: 'modal'
        }
    ],
    canActivate: [AuthGuard]
};
